import * as React from "react";

function WalletIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 17.5h3.005a1.5 1.5 0 001.5-1.5V8a1.5 1.5 0 00-1.5-1.5H15A1.5 1.5 0 0116.5 8v8a1.5 1.5 0 01-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 11,
    x: 4.5,
    y: 6.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.75,
    cy: 11.75,
    r: 1.25
  }));
}

export default WalletIcon;